import React, { useState, useRef } from 'react'
import MyButton from '../button/button'
import { commentaryInfo } from '../../services/web/types/responseWebServiceTypes'
import useSnackbarAction from '../../stores/snackbar/snackbarAction'
import useTranslate from '../../i18n/useTranslate'
import { makeStyles } from '@material-ui/core'

export type CopyToClipboardViewType = CopyToClipboardPropsType
enum PageType {
    ReviewerCommentPage = '1', // หน้าบันทึกข้อคิดเห็นกรรมการ
    SynthesisPage = '2', // หน้าสังเคราะห์ข้อคิดเห็น
}

export const CopyToClipboardView: React.FC<CopyToClipboardViewType> = (props) => {
    const { dataSource, pageType } = props
    const tableRef = useRef(null)
    const [copySuccess, setCopySuccess] = useState('')
    const snackbarAction = useSnackbarAction()
    const translate = useTranslate()
    const classes = useStyles()

    const nameLabel = useRef<string>('')
    const saveCommentDateLabel = useRef<string>('')
    const commentInsteadBy = useRef<string>('')

    React.useEffect(() => {
        if (pageType === PageType.ReviewerCommentPage) {
            nameLabel.current = translate.get('LABEL.COMMITTEE_NAME')
            saveCommentDateLabel.current = translate.get('LABEL.COMMITTEE_MEETING_DATE')
            commentInsteadBy.current = translate.get('LABEL.COMMENT_INSTEAD_BY')
        } else if (pageType === PageType.SynthesisPage) {
            nameLabel.current = translate.get('LABEL.REVIEWER_NAME')
            saveCommentDateLabel.current = translate.get('LABEL.PRESIDENT_MEETING_DATE')
            commentInsteadBy.current = translate.get('LABEL.COMMENT_INSTEAD_BY')
        }
    }, [translate.languageStore.currentLanguage])

    const copyToClip = () => {
        let range = document.createRange()
        //@ts-ignore
        range.selectNodeContents(tableRef.current)

        let sel = window.getSelection()

        if (sel) {
            snackbarAction.openSnackbar({
                message: translate.get('MESSAGE.M020'),
                type: 'success',
            })
            sel.removeAllRanges()
            sel.addRange(range)
            document.execCommand('Copy')
            sel.removeAllRanges()
            //paste the copied data to mailto body
            // document.addEventListener('paste', function (event) {
            //     if (event && event.clipboardData) {
            //         var clipText = event.clipboardData.getData('Text')
            //         console.log('clipText', clipText)
            //         //@ts-ignore
            //         window.location = `mailto:?subject=I wanted you to see this site&body=${clipText}`
            //     }
            // })
        }
    }
    return (
        <div>
            <div ref={tableRef}>
                <div className={classes.container}>
                    {dataSource &&
                        dataSource.map((itm, index) => {
                            return (
                                <div className={classes.spaceLine} key={index}>
                                    <div>
                                        <strong>{nameLabel.current} :</strong>{' '}
                                        {translate.languageStore.currentLanguage === translate.languageKey.th
                                            ? itm.fullNameTH
                                            : itm.fullNameEN}{' '}
                                        {(translate.languageStore.currentLanguage === translate.languageKey.th
                                            ? itm.fullNameTH
                                            : itm.fullNameEN) !==
                                            (translate.languageStore.currentLanguage === translate.languageKey.th
                                                ? itm.updateByNameTH
                                                : itm.updateByNameEN) && (
                                            <>
                                                <strong>{commentInsteadBy.current} :</strong>{' '}
                                                {translate.languageStore.currentLanguage === translate.languageKey.th
                                                    ? itm.updateByNameTH
                                                    : itm.updateByNameEN}{' '}
                                            </>
                                        )}
                                        <strong>{saveCommentDateLabel.current} : </strong>
                                        {itm.updatedDate}{' '}
                                    </div>
                                    {itm.commentaryInfo.map((commentItm, indexComment) => {
                                        return (
                                            <>
                                                <div key={indexComment}>
                                                    {`${indexComment + 1}`}.{' '}
                                                    {translate.languageStore.currentLanguage ===
                                                    translate.languageKey.th
                                                        ? commentItm.name_th
                                                        : commentItm.name_en}{' '}
                                                    :
                                                    <br />
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: commentItm.comment_htmltag ?? '',
                                                        }}
                                                    ></div>
                                                </div>
                                            </>
                                        )
                                    })}
                                    <strong>{translate.get('LABEL.ETHIC_REVIEW_OUTCOME')} :</strong>{' '}
                                    {translate.languageStore.currentLanguage === translate.languageKey.th
                                        ? itm.approveStatusNameTH
                                        : itm.approveStatusNameEN}
                                    <br />
                                </div>
                            )
                        })}
                </div>
            </div>

            {document.queryCommandSupported('copy') && (
                <div style={{ padding: '10px', textAlign: 'end' }}>
                    <MyButton onClick={copyToClip} color={'primary'}>
                        {translate.get('BUTTON.COPY_TO_CLIPBOARD')}
                    </MyButton>
                    {copySuccess}
                </div>
            )}
        </div>
    )
}

export type DatasourceForCopyToClipbaord = {
    fullNameEN: string
    fullNameTH: string
    updatedDate?: string
    updateByNameTH?: string
    updateByNameEN?: string
    approveStatusNameTH?: string
    approveStatusNameEN?: string

    commentaryInfo: commentaryInfo[]
}
export type CopyToClipboardPropsType = {
    dataSource: DatasourceForCopyToClipbaord[]
    pageType: '1' | '2'
}

let CopyToClipboard: React.FC<CopyToClipboardPropsType> = ({ ...others }) => {
    // const styleCustom = { minWidth: '125px', ...others?.style }
    return <CopyToClipboardView {...others} />
}

const useStyles = makeStyles(() => ({
    spaceLine: {
        marginBottom: '30px',
    },
    container: {
        zIndex: -999,
        position: 'absolute',
        opacity: 0,
    },
}))

export default CopyToClipboard
